module.exports = __webpack_public_path__ + "static/media/document-upload.7a78af53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/document-upload.jpg
// module id = 444
// module chunks = 0